import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaTimes } from "react-icons/fa";

const ExpertAvailability = ({ expertDetails }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [availabilities, setAvailabilities] = useState([]);
  const [availabilitySlots, setAvailabilitySlots] = useState([]);
  const token = localStorage.getItem("EXPERT_AUTH_TOKEN");
  const [meetingLink, setMeetingLink] = useState("");
  const [fetchedMeetLink, setFetchedMeetLink] = useState("");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [clickedDate, setClickedDate] = useState(null);

  // const expertDetails = localStorage.getItem("EXPERT_INFO");
  const getUserDetails = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/expert/${expertDetails.email}`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        console.log(data.data);
        setFetchedMeetLink(data.data.meetLink);
      } else {
        console.error("Error fetching meetings Link:", response.status);
      }
    } catch (error) {
      console.error("Error fetching meetings data:", error);
    }
  };

  const getMeetingsData = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/session/${expertDetails._id}`, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setAvailabilities(data.data);
      } else {
        console.error("Error fetching meetings data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching meetings data:", error);
    }
  };

  const handleDateClick = (date) => {
    setClickedDate(date);
  };

  //handling changes
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value);
  };

  const handleAddSlot = () => {
    if (selectedDate && selectedTime) {
      const newSlot = {
        date: selectedDate,
        time: selectedTime,
      };
      setAvailabilitySlots([...availabilitySlots, newSlot]);
      setSelectedTime("");
    }
  };

  //handle to remove selected session
  const handleRemoveSlot = (index) => {
    const updatedSlots = availabilitySlots.filter((_, i) => i !== index);
    setAvailabilitySlots(updatedSlots);
  };

  //handling Availability onClick
  const handleUpdateAvailability = async (event) => {
    setSelectedDate(null);
    setSelectedTime("");
    event.preventDefault();
    if (availabilitySlots.length > 0) {
      try {
        const response = await fetch(`${baseUrl}/api/session/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(availabilitySlots),
        });

        if (response.ok) {
          console.log("Availability updated:", availabilitySlots);
          getMeetingsData();
          setAvailabilitySlots([]);
          toast.success("Availability updated", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          const responseData = await response.json();

          console.error(
            "Error updating availability:",
            response.status,
            responseData.error.message
          );

          toast.error(
            `Error updating availability: ${responseData.error.message}`,
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
            }
          );
        }
      } catch (error) {
        console.error("Error sending request:", error);
        toast.error("Error updating availability", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }
  };

  //handling updateMeet onClick
  const handleUpdateMeetingLink = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/expert/updateMeetLink`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({ meetingLink }),
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log("Meeting link updated:", responseData);
        getUserDetails();
        toast.success("Meet link updated", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else {
        console.error("Error updating meeting link:", response.status);
        toast.error("Error updating meet link", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error sending request:", error);
      toast.error("Error updating meet link", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  };

  const timeOptions = [];
  for (let hour = 0; hour <= 23; hour++) {
    for (let minute = 0; minute <= 30; minute += 30) {
      const formattedHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      const ampm = hour < 12 ? "AM" : "PM";
      const formattedMinute = minute === 0 ? "00" : "30";
      const time = `${formattedHour}:${formattedMinute} ${ampm}`;
      timeOptions.push(time);
    }
  }

  const upcomingDates = [];

  //handling delete availabilit
  const handleDelete = async (meetingId) => {
    try {
      const headers = {
        Authorization: `${token}`,
      };

      const response = await fetch(`${baseUrl}/api/session/${meetingId}`, {
        method: "DELETE",
        headers: headers,
      });

      if (response.ok) {
        // If the backend returns a message or data, you can handle it here
        const responseBody = await response.json(); // or response.text() if applicable
        console.log("Deleted slot response:", responseBody);

        setAvailabilities(
          availabilities.filter((meeting) => meeting._id !== meetingId)
        );

        toast.success("Slot deleted successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else {
        console.error("Error deleting slot:", response.status);
        toast.error("Error deleting slot", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error deleting slot:", error);
      toast.error("Error deleting slot", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  };

  const uniqueDates = Array.from(
    new Set(availabilities.map((avail) => avail.date))
  );

  useEffect(() => {
    getMeetingsData();
    getUserDetails();
  }, []);

  return (
    <div className="flex bg-gray-100 h-screen">
      <div className="w-2/3 m-14 bg-white p-10 rounded-lg flex flex-col">
        <div className="max-w-md p-5">
          <h2 className="text-2xl font-semibold mb-4">Update Availability</h2>
          <form onSubmit={handleUpdateAvailability}>
            <div className="mb-4 w-full">
              <label className="block font-semibold mb-1">Select Date:</label>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                minDate={new Date()}
                highlightDates={upcomingDates}
                className="w-full bg-gray-100 p-2 border rounded-md"
              />
            </div>
            <div className=" w-full">
              <label className="block font-semibold mb-1">Select Time:</label>
              <select
                value={selectedTime}
                onChange={handleTimeChange}
                className="bg-gray-100 w-2/3 p-2 border rounded-md"
                required
              >
                <option value="">Select a time</option>
                {timeOptions.map((time, index) => (
                  <option key={index} value={time}>
                    {time}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="ml-2 bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600"
                onClick={handleAddSlot}
              >
                Add Slot
              </button>
            </div>
            <div>
              {availabilitySlots.map((slot, index) => (
                <div key={index} className="flex items-center mb-2">
                  <p className="mr-2">
                    {slot.date.toDateString()} - {slot.time}
                  </p>
                  <button
                    type="button"
                    className="text-red-500 hover:text-red-700"
                    onClick={() => handleRemoveSlot(index)}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
            <button
              type="submit"
              className="mt-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
              onClick={handleUpdateAvailability}
            >
              Update Availability
            </button>
          </form>
        </div>
        <div className="max-w-md p-5">
          <input
            type="text"
            value={meetingLink}
            onChange={(event) => setMeetingLink(event.target.value)}
            className="w-2/3 bg-gray-100 rounded p-2"
            placeholder="Enter meeting link"
          />
          <button
            className="mt-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            onClick={handleUpdateMeetingLink}
          >
            Update Meet Link
          </button>
        </div>
      </div>
      <div className="w-1/3 m-14 bg-white p-2 rounded-lg flex flex-col ml-2">
        <div className="flex-1 pt-12">
          <h2 className="text-xl font-bold">Your Availability</h2>
          {availabilities.length === 0 ? (
            <p className="text-gray-600">
              Your selected date and time will be shown here. This will reflect
              on the website to the users. Kindly consistently update date &
              time for a smooth user experience and greater earning opportunity.
            </p>
          ) : (
            <div className="grid grid-cols-2 gap-2 mt-4 mb-4">
              {uniqueDates.map((date) => (
                <div
                  key={date}
                  className={`p-2 rounded ${
                    clickedDate === date
                      ? "bg-gray-100 text-black border-2 border-black"
                      : "bg-gray-100"
                  } cursor-pointer`}
                  onClick={() => handleDateClick(date)}
                >
                  {new Date(date).toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "short",
                  })}
                </div>
              ))}
            </div>
          )}
          {clickedDate && (
            <div>
              <h3 className="text-lg font-semibold mb-2">
                Times for{" "}
                {new Date(clickedDate).toLocaleDateString("en-US", {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                })}
              </h3>
              <div className="grid grid-cols-2 gap-2">
                {availabilities
                  .filter((avail) => avail.date === clickedDate)
                  .map((avail, index) => (
                    <div
                      key={index}
                      className="p-2 bg-gray-100 rounded flex items-center"
                    >
                      <span className="mr-2">{avail.time}</span>
                      <button
                        className="bg-red-500 text-white py-1 px-2 rounded"
                        onClick={() => handleDelete(avail._id)}
                      >
                        <span className="hidden">Delete</span>
                        <FaTimes className="h-4 w-4" />
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
        <div className="p-4 bg-gray-100 rounded shadow-md">
          <h3 className="text-xl font-semibold mb-2">Your Meet Link</h3>
          {!fetchedMeetLink ? (
            <p className="text-gray-600">
              Your selected meeting link will be shown here. The user will join
              via this link for a session with you.
            </p>
          ) : (
            <div className="bg-white p-2 rounded border border-gray-300">
              <a
                href={fetchedMeetLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                {fetchedMeetLink}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpertAvailability;
